import * as React from 'react';
import * as $ from 'jquery';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import * as _ from "lodash";

const emptyStyle = {
    background: "#fff"
}

interface IState {
    loading: boolean,
    saving: boolean
    rawdata: Array<any>
    data: Array<any>
    pages: any
    sorted: Array<any>
    filtered: Array<any>
    resetdata: boolean
    resScan: {
        dataExport: any,
        rekap: any,
        favLema: any
    }
}

export default class Dashboard extends React.Component<any, IState> {
    private url: any;

    constructor(props: any) {
        super(props);
        this.state = {
            loading: false,
            saving: false,
            rawdata: [],
            data: [],
            pages: null,
            sorted: [],
            filtered: [],
            resetdata: true,
            resScan: {
                dataExport: [],
                rekap: {},
                favLema: []
            }
        }
        this.fetchData = this.fetchData.bind(this);
    }

    componentWillMount() {
        this.url = window.location.origin;
        if (window.location.port === "8080") {
            this.url = this.url.replace("8080", "3000");
        } else if(window.location.port === "") {
            this.url = this.url + ":1000";
        }
        
    }

    get emptyLema() {
        // return this.state.resScan.dataExport.length === 0;
        return this.emptyFavLema && this.emptyRekap;
    }

    get emptyFavLema() {
        // return this.state.resScan.dataExport.length === 0;
        if (this.state.resScan.favLema === null) return true;
        return this.state.resScan.favLema.length === 0;
    }

    get emptyRekap() {
        return Object.keys(this.state.resScan.rekap).length === 0;
    }

    get rekap() {
        const rekap = this.state.resScan.rekap;
        if (!this.emptyRekap) {
            return {
                "Halaman": rekap.Page,
                "Kalimat": rekap.Sentence,
                "Kata": rekap.Kata,
                "Lema": rekap.Lema,
                "Prefiks": Object.keys(rekap.Prefiks).length,
                "Infiks": Object.keys(rekap.Infiks).length,
                "Sufiks": Object.keys(rekap.Sufiks).length,
                "Konfiks": Object.keys(rekap.Konfiks).length,
                "Majemuk": rekap.Majemuk,
                "Ulang": rekap.Ulang
            }
        }
        return rekap;
    }

    get favLema() {
        let temp = this.state.resScan.favLema;
        let favLema = [];

        if (temp === null) return [];

        let maxLema = this.state.resScan.favLema.length > 10 ? 10 : this.state.resScan.favLema.length;

        let i = 0;
        do {
            favLema.push(temp[i]);
            i++;
        }
        while (i < maxLema);

        return favLema;
    }

    getAnalisis() {
        return new Promise(resolve => {
            if (this.state.rawdata.length > 0 && !this.state.resetdata) resolve(this.state.rawdata);

            const self = this;
            $.ajax({
                type: "POST",
                url: this.url + "/api/db/queryAll",
                data: { sql: "SELECT * FROM analisis ORDER BY timestamp DESC" },
                dataType: "JSON"
            }).done(function (res: any) {
                if (res.status === "error") {
                    console.error(res);
                    alert("Error !!!")
                } else {
                    if (res.msg === null) res.msg = [];
                    self.setState({ rawdata: res.msg, resetdata: false })
                    resolve(res.msg);
                }
            }).fail(function (res: any) {
                console.error(res);
                alert("Failed");
            });
        })
    }

    requestData(pageSize: any, page: any, sorted: any, filtered: any) {
        return new Promise((resolve, reject) => {
            this.getAnalisis().then((filteredData: any) => {
                // You can use the filters in your request, but you are responsible for applying them.
                if (filtered.length) {
                    filteredData = filtered.reduce((filteredSoFar: any, nextFilter: any) => {
                        return filteredSoFar.filter((row: any) => {
                            if (nextFilter.id === 'timestamp') {
                                return (this.converttime(row[nextFilter.id]) + "").includes(nextFilter.value.toLowerCase());
                            } else {
                                return (row[nextFilter.id].toLowerCase() + "").includes(nextFilter.value.toLowerCase());
                            }
                        });
                    }, filteredData);
                }
                // You can also use the sorting in your request, but again, you are responsible for applying it.
                const sortedData = _.orderBy(
                    filteredData,
                    sorted.map((sort: any) => {
                        return (row: any) => {
                            if (row[sort.id] === null || row[sort.id] === undefined) {
                                return -Infinity;
                            }
                            return typeof row[sort.id] === "string"
                                ? row[sort.id].toLowerCase()
                                : row[sort.id];
                        };
                    }),
                    sorted.map((d: any) => (d.desc ? "desc" : "asc"))
                );

                // You must return an object containing the rows of the current page, and optionally the total pages number.
                const res = {
                    rows: sortedData.slice(pageSize * page, pageSize * page + pageSize),
                    pages: Math.ceil(filteredData.length / pageSize)
                };

                // Here we'll simulate a server response with 500ms of delay.
                setTimeout(() => resolve(res), 500);
            })
        });
    };

    fetchData(state: any, instance: any = null) {
        // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
        // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
        this.setState({ loading: true });
        // Request the data however you want.  Here, we'll use our mocked service we created earlier
        this.requestData(
            state.pageSize,
            state.page,
            state.sorted,
            state.filtered
        ).then((res: any) => {
            // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
            this.setState({
                data: res.rows,
                pages: res.pages,
                loading: false
            });
        });
    }

    resetData() {
        this.setState({
            sorted: [],
            filtered: []
        });
    }

    viewHistory(idx: any) {
        const data = this.state.data[idx]
        this.setState({
            resScan: {
                dataExport: [],
                rekap: JSON.parse(data.rekap),
                favLema: JSON.parse(data.favlema)
            }
        })
    }

    handleDelete(id: any) {
        if (!confirm("Klik ok untuk melanjutkan")) return
        this.setState({ saving: true });

        const self = this;

        $.ajax({
            type: "POST",
            url: this.url + "/api/db/delete",
            data: { table: "analisis", params: JSON.stringify({ id: id }) },
            dataType: "JSON"
        }).done(function (res: any) {
            if (res.status === "error") {
                console.error(res);
                alert("Error !!!");
            } else {
                alert("Seccess !!!");
            }
            self.setState({ saving: false, resetdata: true }, () => self.resetData());
        }).fail(function (res: any) {
            console.error(res);
            alert("Failed !!!");
            self.setState({ saving: false });
        });
    }

    leftpad(pad: string, str: string) {
        if (typeof str === 'undefined')
            return "";
        return (pad + str).slice(-2);

    }

    converttime(val: any) {
        var dt = new Date(val * 1000);
        // return ('' + dt.toString().split(" GMT")[0]);
        const day = this.leftpad("0", dt.getDate().toString());
        const month = this.leftpad("0", dt.getMonth().toString());
        const year = dt.getFullYear().toString();
        return (day + '-' + month + '-' + year);

    }

    render() {
        const columns = [
            {
                Header: '#',
                Cell: (props: any) => <div style={{ textAlign: "center" }}>{props.index + 1}</div>,
                width: 50,
                filterable: false,
            }, {
                Header: 'Buku',
                accessor: 'buku', // String-based value accessors!
            }, {
                Header: 'Time',
                accessor: 'timestamp', // String-based value accessors!
                width: 150,
                Cell: (props: any) => (<div style={{ textAlign: "center" }}>{this.converttime(props.value)}</div>)
            }, {
                Header: '#',
                accessor: 'id', // String-based value accessors!
                width: 100,
                filterable: false,
                Cell: (props: any) => (<div style={{ textAlign: "center" }}>
                    <a href="#" className="btn btn-sm btn-primary" onClick={() => this.viewHistory(props.index)}><i className="icon icon-search"></i></a>&nbsp;
                    <a href="#" className="btn btn-sm btn-error" onClick={() => this.handleDelete(props.value)}><i className="icon icon-delete"></i></a>
                </div>)
            }]

        return <div>
            <div style={{ padding: 25 }}>
                <div className="columns">
                    <div className="column col-6 col-xs-4">
                        <div className="panel">
                            <div className="panel-header" style={{ fontWeight: 800 }}>
                                <div className="panel-title">
                                    List Buku
                                </div>
                            </div>
                            <div className="panel-body">
                                <ReactTable
                                    manual={true}
                                    data={this.state.data}
                                    columns={columns}
                                    // Controlled props
                                    sorted={this.state.sorted}
                                    filtered={this.state.filtered}
                                    // 
                                    onSortedChange={sorted => this.setState({ sorted })}
                                    onFilteredChange={filtered => this.setState({ filtered })}

                                    pages={this.state.pages}
                                    defaultPageSize={10}
                                    filterable={true}
                                    className="-striped -highlight"
                                    loading={this.state.loading}
                                    onFetchData={this.fetchData}
                                />
                            </div>
                            <div className="panel-footer">
                            </div>
                        </div>
                    </div>
                    <div className="column col-3 col-xs-4">
                        <div className="panel">
                            <div className="panel-header" style={{ fontWeight: 800 }}>
                                <div className="panel-title">Jumlah Kata</div>
                            </div>
                            <div className="panel-body">
                                {this.emptyRekap && <div className="empty" style={emptyStyle}>
                                    <div className="empty-icon">
                                        <i className="icon icon-stop icon-2x"></i>
                                    </div>
                                    <p className="empty-title h5">Empty</p>
                                    <p className="empty-subtitle">No document selected</p>
                                </div>}

                                {!this.emptyLema && <table className="table">
                                    <tbody>
                                        {Object.keys(this.rekap).map((k: any, i: any) => {
                                            return <tr key={i}>
                                                <td style={{ width: "10%" }}>{i + 1}</td>
                                                <td style={{ width: "65%" }}>Jumlah {k}</td>
                                                <td style={{ textAlign: "right" }}>{this.rekap[k]}</td>
                                            </tr>
                                        })}
                                    </tbody>
                                </table>}
                            </div>
                            <div className="panel-footer">
                            </div>
                        </div>
                    </div>
                    <div className="column col-3 col-xs-4">
                        <div className="panel">
                            <div className="panel-header" style={{ fontWeight: 800 }}>
                                <div className="panel-title">Lema Terbanyak</div>
                            </div>
                            <div className="panel-body">
                                {this.emptyFavLema && <div className="empty" style={emptyStyle}>
                                    <div className="empty-icon">
                                        <i className="icon icon-stop icon-2x"></i>
                                    </div>
                                    <p className="empty-title h5">Empty</p>
                                    <p className="empty-subtitle">No document selected</p>
                                </div>}

                                {!this.emptyFavLema && <table className="table">
                                    <tbody>
                                        {this.favLema.map((d: any, i: any) => {
                                            return <tr key={i}>
                                                <td style={{ width: "10%" }}>{i + 1}</td>
                                                <td style={{ width: "65%" }}>{d.Item}</td>
                                                <td style={{ textAlign: "right" }}>{d.Count}</td>
                                            </tr>
                                        })}
                                    </tbody>
                                </table>}
                            </div>
                            <div className="panel-footer">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/pages/admin/Dashboard.tsx